// Shared background image URLs for RxGRIT pages
export const HIKERS_HERO_IMAGE = 'https://customer-assets-eiarnc6j.emergentagent.net/job_39ce99f8-2df7-4a5a-9cad-1b3f94f84fe9/artifacts/a92tytn3_Yvette%20%26%20lady%20hiking%20Menopause%20promo%20.png';

// Full-page hero (used on login, leaderboard, my-summaries) — starts at top of page,
// so the top-of-image overlay gradient looks natural.
export const hikersHeroBgStyle = {
  backgroundImage: `linear-gradient(to bottom, rgba(245,244,241,0.72) 0%, rgba(245,244,241,0.88) 55%, rgba(245,244,241,0.96) 100%), url("${HIKERS_HERO_IMAGE}")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center top',
  backgroundAttachment: 'fixed',
  backgroundRepeat: 'no-repeat',
};

// Section variant (used on the dashboard "10 Daily GRIT Practices" section) —
// applied to a mid-page section rather than the full page, so we:
//  • use `backgroundAttachment: 'scroll'` (iOS Safari ignores `fixed` on mobile
//    and clips oddly — scroll behaves consistently everywhere),
//  • use a lighter, uniform overlay so the hikers are still recognisable,
//  • center-position vertically so faces show within the section slice.
export const hikersSectionBgStyle = {
  backgroundImage: `linear-gradient(rgba(245,244,241,0.62), rgba(245,244,241,0.72)), url("${HIKERS_HERO_IMAGE}")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center 30%',
  backgroundAttachment: 'scroll',
  backgroundRepeat: 'no-repeat',
};
